export default __webpack_public_path__ + "static/bee-d4b22aa60e2dc45e5a0b6b277b7b9f43.svg";